<div class="mainContent">
  <!-- Header -->
  <div style="margin-bottom: 1rem;">
    <div>
      <label
        i18n="@@AddAdhocActivity"
        class="textColour"
        [ngStyle]="{ 'border-color': buttonColor }"
      >
        {{ titleText }}
      </label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <form [formGroup]="adhocActivityForm">
    <!-- Step 1: Dropdown Section -->
    <div *ngIf="!showConfigForm" class="step-one-container">
      <div class="d-flex mb-3" style="gap: 1rem">
        <!--@modified By Rahul Vk
            @note:-Displaying List of Products for the Strategies that are approved @state code = 4
            @date :- 10/11/25 -->
        <!-- select Product   -->
        <mat-form-field appearance="outline" class="w-75 mb-3">
          <mat-label>Select Product </mat-label>
          <mat-select formControlName="pssName" (selectionChange)="onPssSelected($event.value)">
            <mat-option *ngFor="let pss of pssList" [value]="pss">
              {{ pss.ProductName }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="adhocActivityForm.get('pssName')?.hasError('required')"
          >
            Please select a Product
          </mat-error>
        </mat-form-field>

        <!-- Activity Name -->
      <mat-form-field appearance="outline" class="w-75 mb-3">
        <mat-label>Activity Name</mat-label>
        <mat-select formControlName="activitySelect" (selectionChange)="onActivityChange($event.value)">
          <mat-option value="Others">  <em  class="fas fa-plus-circle" style="font-size: 16px;
    padding: 0 5px;padding-left: 0;"></em>Create New Activity</mat-option>
           <mat-divider></mat-divider>
          <mat-option *ngFor="let act of activitiesList" [value]="act.activityName">
            {{ act.activityName }}
          </mat-option>
          
        </mat-select>

        <mat-error *ngIf="adhocActivityForm.get('activitySelect')?.hasError('required')">
          Please select an activity
        </mat-error>
      </mat-form-field>
       </div>

<!-- Custom Activity when Other is selected -->
<!-- <div *ngIf="isOtherSelected" class="w-100 mb-3">

  <mat-form-field appearance="outline"  class="w-100 mb-2">
    <mat-label>Enter Activity Name</mat-label>
    <input
      matInput
      formControlName="activityName"
      placeholder="Enter activity"
    />
    <mat-error *ngIf="adhocActivityForm.get('activityName')?.hasError('required')">
      Activity name is required
    </mat-error>
    <mat-error *ngIf="adhocActivityForm.get('activityName')?.hasError('specialCharacter')">
      Special characters are not allowed
    </mat-error>
  </mat-form-field>
</div> -->



     

      <!-- Buttons -->
      <div class="d-flex justify-content-end mt-3" style="gap: 1rem">
        <!-- <button mat-stroked-button class="me-2" (click)="closeDialog()">
          Cancel
        </button> -->

        	<app-common-button
          label="Cancel"
          title="Cancel "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="closeDialog()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        <!-- <button
          mat-raised-button
          [style.background-color]="backgroundColorButton"
          (click)="onNext()"
        >
          Next
        </button> -->
        		  <app-common-button
          label="Next"
          title="Next "
          [buttonId]="1111"
			    width="110px"
          [critical]="false"
          (clicked)="onNext()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
      </div>
    </div>

    <!-- Step 2: Configuration Section -->
    <div
      *ngIf="showConfigForm"
      class="config-container mt-4 p-3 border rounded"
    >
      <h4 class="text-primary mb-3">
        Configure Activity - {{ adhocActivityForm.get("activityName")?.value }}
      </h4>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Level</mat-label>
            <mat-select formControlName="level" [disabled]="true">
              <mat-option *ngFor="let lvl of levels" [value]="lvl.lookupvalue">
                {{ lvl.lookupvalue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="adhocActivityForm.get('level')?.hasError('required')"
            >
              Please select a Level
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Review Period</mat-label>
            <mat-select formControlName="reviewPeriod">
              <mat-option *ngFor="let p of reviewPeriods" [value]="p">
                {{ p }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                adhocActivityForm.get('reviewPeriod')?.hasError('required')
              "
            >
              Please select a Review Period
            </mat-error>
          </mat-form-field>
        </div>
      </div>

<div class="row">
  <!-- Due Days -->
  <div class="col-md-6">
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Due Days</mat-label>
      <input matInput type="number" formControlName="dueDays" />
      <mat-error *ngIf="adhocActivityForm.get('dueDays')?.hasError('required')">
        Due Days is required
      </mat-error>
      <mat-error *ngIf="adhocActivityForm.get('dueDays')?.hasError('min')">
        Due Days must be greater than or equal to 1
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Start Date -->
  <div class="col-md-3">
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        [min]="minDate"
      />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error *ngIf="adhocActivityForm.get('startDate')?.hasError('required')">
        Please select a Start Date
      </mat-error>
    </mat-form-field>
  </div>

  <!-- End Date -->
  <div class="col-md-3">
    <mat-form-field appearance="outline" class="w-100 mb-3">
      <mat-label>End Date</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        formControlName="endDate"
        [min]="minDate"
      />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
      <mat-error *ngIf="adhocActivityForm.get('endDate')?.hasError('required')">
        Please select an End Date
      </mat-error>
    </mat-form-field>
  </div>
</div>


      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Duration (Hours)</mat-label>
        <input matInput type="number" min="0" formControlName="durationHours" />
        <mat-error *ngIf="adhocActivityForm.get('durationHours')?.hasError('required')">
        Duration Hours is required
      </mat-error>
      <mat-error *ngIf="adhocActivityForm.get('durationHours')?.hasError('min')">
        Duration Hours must be greater than or equal to 1
      </mat-error>
      </mat-form-field>

      <mat-label>Evidence Required?</mat-label>
      <mat-radio-group
        formControlName="evidenceRequired"
        class="d-flex gap-4 mb-3"
      >
        <mat-radio-button value="Yes" class="mr-4">Yes</mat-radio-button>
        <mat-radio-button value="No" class="mr-4">No</mat-radio-button>
      </mat-radio-group>

      <mat-form-field appearance="outline" class="w-100 mb-3">
        <mat-label>Upload Instructions</mat-label>
        <input matInput formControlName="uploadInstructions" />
        <mat-error *ngIf="adhocActivityForm.get('uploadInstructions')?.hasError('specialCharacter')">
          Special characters not allowed
        </mat-error>
      </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Roles Allowed</mat-label>
            <input
              matInput
              formControlName="rolesAllowed"
              [value]="UserRoleName"
              readonly
            />
          </mat-form-field> -->
          
  <!-- Reason for New Activity -->
   <!-- @Added By Rahul Vk -->
  <mat-form-field appearance="outline" class="w-100 mb-2">
    <mat-label>Description for Activity</mat-label>
    <textarea
      matInput
      formControlName="descriptionForNewActivity"
      placeholder="Enter reason"
      rows="3">
    </textarea>
    <mat-error *ngIf="adhocActivityForm.get('descriptionForNewActivity')?.hasError('required')">
      Description is required
    </mat-error>
    <mat-error *ngIf="adhocActivityForm.get('descriptionForNewActivity')?.hasError('specialCharacter')">
      Special characters are not allowed
    </mat-error>
  </mat-form-field>

      <div class="d-flex justify-content-between mt-3 align-items-center">

         <!-- <button mat-stroked-button class="me-2" (click)="backtoSelection()">
          Back
        </button> -->

        	<app-common-button
          label="Back"
          title="Back "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="backtoSelection()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

        <div class="d-flex" style="gap: 1rem">
        <!-- <button mat-stroked-button class="me-2" (click)="closeDialog()">
          Cancel
        </button> -->
        	<app-common-button
          label="Cancel"
          title="Cancel "  
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="closeDialog()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        <!-- <button
          mat-raised-button
          [style.background-color]="backgroundColorButton"
          (click)="submit()"
        >
          Submit
        </button> -->

        		  <app-common-button
          label="Submit"
          title="Submit "
		     
          [buttonId]="1111"
			    width="110px"
          [critical]="false"
          (clicked)="submit()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        </div>
      </div>
    </div>
  </form>
</div>
